<template>
  <kiosk-modal-root v-if="component.properties.element_type === 'modal'"
    :data-root="true"
    :session-uuid="sessionUuid"
    :key="component.uuid"
    :page-component="component"
    :parentComponent="parentComponent"
    :kioskProperties="kioskProperties" />
  <kiosk-carousel-root v-else-if="component.properties.element_type === 'carousel'"
    :data-root="true"
    :key="component.uuid"
    :session-uuid="sessionUuid"
    :page-component="component"
    :parentComponent="parentComponent"
    :kioskProperties="kioskProperties" />
  <kiosk-form-root v-else-if="component.properties.element_type === 'form'"
    :data-root="true"
    :key="component.uuid"
    :session-uuid="sessionUuid"
    :page-component="component"
    :parentComponent="parentComponent"
    :kioskProperties="kioskProperties" />
  <kiosk-drag-and-drop-root v-else-if="component.properties.element_type === 'drag_and_drop'"
    :data-root="true"
    :key="component.uuid"
    :session-uuid="sessionUuid"
    :page-component="component"
    :parentComponent="parentComponent"
    :kioskProperties="kioskProperties" />
  <kiosk-bounding-box-root v-else-if="component.properties.element_type === 'bounding_box'"
    :data-root="true"
    :key="component.uuid"
    :session-uuid="sessionUuid"
    :page-component="component"
    :parentComponent="parentComponent"
    :kioskProperties="kioskProperties"
    :parent-session-uuid="sessionUuid" />
  <kiosk-scrollable-area v-else-if="component.properties.element_type === 'scrollable_area'"
    :data-root="true"
    :key="component.uuid"
    :session-uuid="sessionUuid"
    :page-component="component"
    :parentComponent="parentComponent"
    :kioskProperties="kioskProperties" />
  <kiosk-generic-component v-else
    :data-root="true"
    :key="component.uuid"
    :session-uuid="sessionUuid"
    :page-component="component"
    :parentComponent="parentComponent"
    :kioskProperties="kioskProperties" />
</template>

<script>

export default {
  name: 'KioskParentComponents',
  components: {
    KioskBoundingBoxRoot: () => import('./kiosk-bounding-box-root.vue'),
    KioskDragAndDropRoot: () => import('./kiosk-drag-and-drop-root.vue'),
    KioskFormRoot: () => import('./kiosk-form-root.vue'),
    KioskCarouselRoot: () => import('./kiosk-carousel-root.vue'),
    KioskModalRoot: () => import('./kiosk-modal-root.vue'),
    KioskGenericComponent: () => import('./kiosk-generic-component.vue'),
    KioskScrollableArea: () => import('./kiosk-scrollable-area.vue'),
  },
  props: {
    pageComponents: Array,
    parentComponent: Object,
    component: Object,
    kioskProperties: Object,
    sessions: Object,
  },
  data() {
    return {
      sessionUuid: null,
    };
  },
  created() {
    this.getSessionUuid();
  },
  watch: {
    sessions() {
      this.getSessionUuid();
    },
  },
  methods: {
    getSessionUuid() {
      const componentKey = `component_${this.component.id}`;
      const session = this.sessions[componentKey];
      if (session) {
        if (this.sessionUuid !== session.session_uuid) {
          this.sessionUuid = session.session_uuid;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
